import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "$4093 June sidehustle report",
  "description": "",
  "published": "2017-07-03T00:00:00.000Z",
  "redirect_from": ["/blog/4093-june-sidehustle-report/swizec/7681"],
  "categories": "Business, Side Projects",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Today’s livecoding session is postponed until tomorrow evening due to uncharacteristically nice weather in SF and access to a pool `}<a parentName="p" {...{
          "href": "https://t.co/WC3RMHl2hw"
        }}>{`pic.twitter.com/WC3RMHl2hw`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/876537115760222208"
      }}>{`June 18, 2017`}</a></blockquote>
    <p>{`June was a wonderful month. Just brilliant.`}</p>
    <p>{`My video about getting a `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=ed2xrQt0Qp4"
      }}>{`new 2017 Macbook Pro`}</a>{` got 1000 views. My first ever video to do so in a reasonable amount of time. I have some old ones that got that much over like 6 years but that doesn't count.`}</p>
    <p>{`Honestly it's the best video I ever made. Took some advice from Casey's `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=Q980C74SdYQ"
      }}>{`how to vlog like Casey`}</a>{` video. More cinematic shots, less first person shaky cam, more attention to having a real story arc.`}</p>
    <p>{`It worked. Now I just gotta figure out how I can make all my videos like that. And how can I make more videos in the first place. I'd love for each and every of my articles/blogposts to have a video attached to it, but there just aren't enough hours in the day.`}</p>
    <p>{`Or I'm too slow at making the things :)`}</p>
    <p>{`Oh and `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/first-day-new-2017-macbook-pro/swizec/7643"
      }}>{`I got a new laptop`}</a>{`! Paid for in full by the sidehustle. Achievement unlocked! Although it did create some cashflow problems 🤔`}</p>
    <p>{`If you're buying a new $3000 laptop, don't at the same time forget about an unpaid $2500 invoice for your tax accountant who `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/how-i-got-boned-by-taxes-two-years-in-a-row/swizec/7582"
      }}>{`probably saved you plenty of money on taxes`}</a>{`. Probably ... Not like I can afford a second opinion at these rates :D`}</p>
    <p>{`What else?`}</p>
    <p>{`Oh! I ran a `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/initial-results-patreon-experiment/swizec/7666"
      }}>{`Patreon experiment`}</a>{` and I can't decide if it was a smashing success or an abject failure. But the sidehustle does have $46 in monthly recurring revenue now.`}</p>
    <p>{`I'll figure out how to grow that I'm sure. It's like traffic and email subscribers. Getting a bunch of people to your blog is great, but if you can turn them into subscribers who keep coming back, then you're actually building something.`}</p>
    <p>{`Same with selling. Subscribers trump one offs. You can build a real scalable business on stuff that people come back to buy. Very hard to build a scalable business on stuff people buy once and never need again.`}</p>
    <p>{`So here's June in numbers 👇`}</p>
    <p><strong parentName="p">{`Total revenue:`}</strong>{` $4,093`}</p>
    <p><strong parentName="p">{`Gumroad sales:`}</strong>{` $1064 - React+D3v4: $735 - fees - React+D3 ES6: $383 - fees - ES6 Cheatsheet: $22 - fees`}</p>
    <p><strong parentName="p">{`Leanpub sales:`}</strong>{` $418 - Why Programmers Work at Night: $24 - React+D3: $20 - React+D3 ES6: $374`}</p>
    <p>{`Why do people still buy the very first edition of React+D3? I should retire it 🤔`}</p>
    <p><strong parentName="p">{`React Native School:`}</strong>{` $1467`}</p>
    <p><strong parentName="p">{`Packt Quarterly Royalties:`}</strong>{` $865`}</p>
    <p><strong parentName="p">{`Time investment:`}</strong>{` 60 hours`}</p>
    <p><strong parentName="p">{`Expenses:`}</strong>{` $5041`}</p>
    <ul>
      <li parentName="ul">{`MacBook Pro: $3269`}</li>
      <li parentName="ul">{`Dongles: $178`}</li>
      <li parentName="ul">{`Editor: $500`}</li>
      <li parentName="ul">{`VA: $325`}</li>
      <li parentName="ul">{`Facebook Ads: $236`}</li>
      <li parentName="ul">{`99designs: $200`}</li>
      <li parentName="ul">{`Hosting: $10`}</li>
      <li parentName="ul">{`LiveEdu: $10`}</li>
      <li parentName="ul">{`Drip: $184`}</li>
      <li parentName="ul">{`Mailchimp: $20`}</li>
      <li parentName="ul">{`Flaticon: $10`}</li>
      <li parentName="ul">{`SumoMe: $99`}</li>
    </ul>
    <p>{`I should really merge Drip and Mailchimp and stop using the chimp. It's not like I ever send email to those people anymore, it's just a waste of money. I think the only reason I keep it is because of Why Programmers Work at Night and Leanpub's integration with Mailchimp. And lack of integration with Drip.`}</p>
    <p><strong parentName="p">{`Hourly rate after expenses:`}</strong>{` -$15.8`}</p>
    <p>{`😅`}</p>
    <p>{`This is what you would call a loss month. Oops.`}</p>
    <p>{`But hey, the laptop is going to more than amortize over the next 5 years of its useful lifespan. Even if it's just 4 years, it's gonna be put to work. Hard.`}</p>
    <p><strong parentName="p">{`PS:`}</strong>{` React+D3v4 is almost donesky. Got through test driving most of it, decided to add a chapter on React Native, and my intrepid editor is almost done fixing my grammar fuckups. It's turning out great. Best React book ever.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      